var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewActivityLogListIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 5,
    viewBox: "0 0 6 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.876 2.752C0.876 2.456 0.932 2.18 1.044 1.924C1.156 1.668 1.308 1.444 1.5 1.252C1.692 1.06 1.916 0.908 2.172 0.796C2.428 0.684 2.704 0.628 3 0.628C3.296 0.628 3.572 0.684 3.828 0.796C4.084 0.908 4.308 1.06 4.5 1.252C4.692 1.444 4.844 1.668 4.956 1.924C5.068 2.18 5.124 2.456 5.124 2.752C5.124 3.048 5.068 3.324 4.956 3.58C4.844 3.836 4.692 4.06 4.5 4.252C4.308 4.444 4.084 4.596 3.828 4.708C3.572 4.82 3.296 4.876 3 4.876C2.704 4.876 2.428 4.82 2.172 4.708C1.916 4.596 1.692 4.444 1.5 4.252C1.308 4.06 1.156 3.836 1.044 3.58C0.932 3.324 0.876 3.048 0.876 2.752Z",
    fill: "#484B53"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewActivityLogListIcon);
export default __webpack_public_path__ + "static/media/view-activity-log-list-icon.ebba48132a5b159ee29b95e01be3f5c0.svg";
export { ForwardRef as ReactComponent };